// ** Next Import
import Image from 'next/image'

// ** MUI Imports
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import CardContent from '@mui/material/CardContent'

import CardFeedBack from './CardFeedBack'

// ** Icons Imports
import EmailArrowRightOutline from 'mdi-material-ui/EmailArrowRightOutline'

// ** Constants

// eslint-disable-next-line no-unused-vars
const CardContactUs = props => {
  return (
    <Card>
      <Grid container spacing={6}>
        <Grid item xs={12} sm={7}>
          <CardContent sx={{ padding: theme => `${theme.spacing(3.25, 5.75, 6.25)} !important` }}>
            <Typography variant='h6' sx={{ marginBottom: 3.5 }}>
              Gửi yêu cầu hỗ trợ
            </Typography>
            <Typography variant='body2'>Chúng tôi sẽ phản hồi trong thời gian sớm nhất có thể.</Typography>
            <Divider sx={{ marginTop: 3.5, marginBottom: 2.5 }} />
            <CardFeedBack />
          </CardContent>
        </Grid>
        <Grid
          item
          sm={5}
          xs={12}
          sx={{ paddingTop: ['0 !important', '1.5rem !important'], paddingLeft: ['1.5rem !important', '0 !important'] }}
        >
          <CardContent>
            <Box
              sx={{
                padding: 4,
                backgroundColor: 'action.hover'
              }}
            >
              <Typography variant='h6' sx={{ marginBottom: 0 }}>
                Chúng tôi luôn sẵn sàng lắng nghe
              </Typography>
              <Typography variant='body' sx={{ marginBottom: 0, width: '100%' }}>
                Đừng ngần ngại cho chúng tôi biết về khó khăn của bạn. Mọi ý kiến của cộng đồng đều được trân trọng.
              </Typography>
              <Typography variant='body' sx={{ marginBottom: 2 }}>
                {' Để hệ thống có thể nhanh chóng và chính xác.'}
              </Typography>
              <img src={'/images/app/contact_us_page.png'} alt={'about-us'} width={'100%'} />
              <Divider sx={{ marginTop: 3.5, marginBottom: 2 }} />
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <EmailArrowRightOutline />
                <Box
                  component='a'
                  target='_blank'
                  rel='origin'
                  href={'mailto: ieltssongngu@gmail.com'}
                  sx={{
                    textDecoration: 'none',
                    color: 'primary.main'
                  }}
                >
                  <Typography variant='body' sx={{ marginBottom: 0, marginLeft: 2 }}>
                    ieltssongngu@gmail.com
                  </Typography>
                </Box>
              </Box>
              <Divider sx={{ marginTop: 2, marginBottom: 2 }} />
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <Image src={'/images/app/ic_facebook.png'} alt={'facebook'} width={24} height={24} />
                <Box
                  component='a'
                  target='_blank'
                  rel='origin'
                  href={'https://www.facebook.com/web.hocngoainguhieuqua'}
                  sx={{
                    textDecoration: 'none',
                    color: 'primary.main'
                  }}
                >
                  <Typography variant='body' sx={{ marginBottom: 0, marginLeft: 2 }}>
                    fb.com/web.hocngoainguhieuqua
                  </Typography>
                </Box>
              </Box>
              <Divider sx={{ marginTop: 2, marginBottom: 2 }} />
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <Image src={'/images/app/ic_zalo.png'} alt={'zalo'} width={24} height={24} />
                <Box
                  component='a'
                  target='_blank'
                  rel='origin'
                  href={'https://chat.zalo.me/?phone=0395608813'}
                  sx={{
                    textDecoration: 'none',
                    color: 'primary.main'
                  }}
                >
                  <Typography variant='body' sx={{ marginBottom: 0, marginLeft: 2 }}>
                    {'0395608813'}
                  </Typography>
                </Box>
              </Box>
              <Divider sx={{ marginTop: 2, marginBottom: 3.5 }} />
            </Box>
          </CardContent>
        </Grid>
      </Grid>
    </Card>
  )
}

export default CardContactUs
